import { Steps, Timeline } from "antd";

const tone: Record<string, string> = {
  cancelled: "red",
  failed: "red",
  delivery_failed: "red",
  refunded: "green",
  delivered: "green",
};

function OrderJourney({ order }: { order: any }) {
  const journey = order.journey || [];
  const active = journey.findIndex((step: any) => step.state === "current");
  const lastComplete = [...journey].reverse().findIndex((step: any) => step.state === "complete");
  const completeIndex = lastComplete === -1 ? -1 : journey.length - 1 - lastComplete;
  const current = active >= 0 ? active : completeIndex;
  const done = order.status === "delivered" || order.status === "refunded";
  const failed = ["cancelled", "failed", "delivery_failed"].includes(order.status);

  return (
    <div className="journey-panel">
      <Steps
        size="small"
        current={done ? journey.length - 1 : current}
        status={failed ? "error" : done ? "finish" : current < 0 ? "wait" : "process"}
        items={journey.map((step: any) => ({
          title: step.label,
          description: step.at ? new Date(step.at).toLocaleString() : step.state === "upcoming" ? "Waiting" : "",
        }))}
      />
      {(order.timeline || []).length ? (
        <Timeline
          style={{ marginTop: 18 }}
          items={(order.timeline || []).map((event: any) => ({
            color: tone[event.status] || "blue",
            children: (
              <div>
                <strong>{event.label}</strong>
                <div className="muted">
                  {event.at ? new Date(event.at).toLocaleString() : ""}
                  {event.location ? ` · ${event.location}` : ""}
                  {event.actor_role ? ` · ${event.actor_role}` : ""}
                </div>
                {event.note ? <div>{event.note}</div> : null}
                {event.tracking_id ? (
                  <div className="muted">{[event.carrier, event.tracking_id].filter(Boolean).join(" · ")}</div>
                ) : null}
              </div>
            ),
          }))}
        />
      ) : null}
    </div>
  );
}

export default OrderJourney;
